// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationAvailability_wrapper__bf0iF","title":"LocationAvailability_title__mitf0","valueWrapper":"LocationAvailability_valueWrapper__JqVdV"};